var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    className: "svg-link-btn-thin",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1 6.9c-1.251-1.251-3.197-1.191-4.526.139l-.887.886.605.606.886-.887c1.002-1.001 2.396-1.06 3.318-.139.92.92.861 2.315-.14 3.317l-1.694 1.695c-.478.477-1.076.757-1.683.788a2.132 2.132 0 0 1-1.639-.644l-.605.604a2.991 2.991 0 0 0 2.131.898c.053 0 .104 0 .156-.003.82-.043 1.618-.411 2.244-1.039l1.695-1.694c1.33-1.33 1.39-3.277.139-4.527zm-6.278 9.456c-.477.476-1.072.755-1.679.785-.603.04-1.183-.193-1.637-.647-.454-.454-.678-1.019-.647-1.637.03-.606.31-1.202.785-1.679l1.695-1.695c.996-.997 2.39-1.054 3.311-.133l.606-.605c-1.253-1.25-3.197-1.194-4.522.133L7.04 12.573c-.628.627-.996 1.423-1.036 2.242A2.994 2.994 0 0 0 6.9 17.1c.601.6 1.364.9 2.14.9.84 0 1.697-.348 2.387-1.039l.865-.866-.605-.604-.865.865z"
  }));
};